import type { RouteRecordRaw } from 'vue-router'

const historicalRoutes: RouteRecordRaw = {
  path: '/historical',
  name: 'historical',
  meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.titles.historical' },
  component: () => import('@/pages/historical/HistoricalPage.vue'),
}

export default historicalRoutes
